import dayjs from "dayjs";
import store from "../store";

export default {
  install(Vue) {
    const language = store.state.Language.apiLanguage;
    if (language) {
      const lang = language.slice(0, -3);

      require(`dayjs/locale/${lang}`);

      Vue.prototype.$dayjs = date => dayjs(date).locale(lang);
    }
  }
};
